// tslint:disable-next-line:no-reference
/// <reference path="../typings/index.d.ts" />
// tslint:disable-next-line:no-reference
/// <reference path="index.d.ts" />
import Analytics from '@withlocals/withlocals-analytics';
import { WlWindow } from 'typings/globals/cordova';
import Logger from 'utils/Logger';

declare const window: WlWindow;

export default () => {
  if (window.analBuffer) {
    window.analBuffer.push = (...events) => {
      events.forEach((event) => Analytics.pushBitterbal(event));
    };
    window.analBuffer.forEach((event) => Analytics.pushBitterbal(event));
  }

  Logger.log('Main started');

  return 'loaded';
};
